import React from "react";
import PropTypes from "prop-types";
import { FormattedHTMLMessage } from "react-intl";

export default function Translate(props) {
  return <FormattedHTMLMessage {...props} />;
}

Translate.propTypes = {
  id: PropTypes.string.isRequired
};
